<template>
<div class="searchBox">
    <div class="nav"><img src="../../assets/up.png" alt="" class="revocation" @click="addFn">天津新东方员工管理手册</div>
    <div class="Input"><img src="../../assets/search1.png" alt=""><input type="text" placeholder="搜索" @input="fooInput" v-model="keyword">
        <h5 @click="inputHandle">搜索</h5>
    </div>
    <div class="addPage">
        <p v-for="(item,i) in pageArray" :key="i" @click="addGetPage(item)">{{item}}</p>
    </div>
    <p class="hotTitle" v-if="hotSearchHide">热门搜索</p>
    <div class="hotSearch" v-if="hotSearchHide">
        <p v-for="item in dataHot" :key="item.id" @click="pitchTitle(item.id)">{{item.name}}</p>
    </div>
    <img src="../../assets/noContent.png" alt="" v-show="NoContent" class="NoContentClass">
</div>
</template>

<script>
export default {
    data() {
        return {
            dataHot: [{
                    name: "迟到",
                    id: "1"
                },
                {
                    name: "请假",
                    id: "2"
                },
                {
                    name: "忘打卡",
                    id: "3"
                },
                {
                    name: "薪资查询",
                    id: "4"
                },
                {
                    name: "带薪年假",
                    id: "5"
                },
                {
                    name: "员工旅游",
                    id: "6"
                },
                {
                    name: "员工福利",
                    id: "7"
                },
                {
                    name: "员工优惠",
                    id: "8"
                }
            ],
            keyword: "",
            hotSearchHide: true,
            NoContent: false,
            labourList: ['1', '劳动用工', '劳动合同变更', '劳动合同', '劳动', '三方', '三方协议', '三方协议订单', '三方协议订单流程', '协议订单', '用工', '变更', '变更类型', '变更流程'],
            systemList: ['1', '工时制度', '工时', '考勤', '考勤管理', '加班', '加班管理', '休假', '加班制度', '假勤申请', '考勤', '考勤确认', '假勤申请及考勤确认', '坐班指纹打卡', '指纹打卡', '指纹', '一卡通打卡', '一卡通', '打卡', '教师上课一卡通打卡', '教师上课', '教师上课打卡', '坐班打卡', '法定节假日', '节假日', '带薪休假', '带薪休假期', '带薪年假', '假', '休假', '假期', '请假', '年假', '病假', '婚假', '丧假', '产假', '事假'],
            welfareList: ['1', '薪酬福利', '基本信息及提示', '基本信息', '提示', '薪资查询', '薪资', '查询', '员工福利', '福利', '发薪时间', '发薪', '计薪周期', '计薪', '薪酬', '薪酬提示', '员工福利', '绩效提示', '绩效', '课酬提示', '课酬', '个人所得税提示', '个人所得税', 'EHR', 'EHR系统', 'EHR系统查询', 'EHR系统查询流程', '云办公', '云办公APP', '云办公APP查询', '云办公APP查询流程', '法定', '法定福利', '节日福利', '节日', '生日福利', '生日', '结婚福利', '结婚', '生育福利', '生育', '员工年度体验', '员工年度', '员工旅游', '旅游', '员工报班优惠', '报班优惠', '员工报班', '员工优惠', '员工推荐奖励', '推荐奖励', '员工推荐', '员工奖励', '抚恤', '企业文化', '企业文化微信号', '微信号', '企业微信', '企业文化', '企业微信号', '文化微信号'],
            datumList: ['1', '资料申请', '资料', '申请', '申请流程', '相关资料', '实习证明或在职证明', '在职证明', '实习证明', '实习', '在职', '收入证明', '收入', '人力资源印章', '资源印章', '人力印章', '印章', '人力资源', '劳动合同原件及复印件', '复印件', '劳动合同原件', '劳动合同'],
            financeList: ['1', '财务管理制度与流程', '财务管理制度', '财务管理', '财务', '财务流程', '财务管理流程', '财务管理制度流程', '公司发票信息', '公司发票', '发票信息', '发票', '事前费用申请操作流程', '事前费用申请操作', '事前费用申请', '事前费用', '事前费用流程', '事前流程', '事前费用申请流程', '事前操作', '费用申请操作', '申请操作', '事前费用操作', '借款操作流程', '借款操作流程', '借款', '借款操作', '借款操作', '事后费用报销操作流程', '事后费用报销操作', '事后费用报销流程', '事后费用报销', '事后费用', '费用报销操作流程', '费用报销', '费用报销操作', '报销操作流程', '报销操作'],
            assetList: ['1', '资产管理制度与流程', '资产管理制度与流程', '资产管理制度流程', '资产管理流程', '资产管理流程', '资产流程', '资产', 'OA采购申请流程', '采购申请流程', '采购流程', '采购申请人提交OA采购申请', '采购申请人提交采购申请', '采购申请', '采购申请人提交', '采购申请人', '费控事前采购申请流程', '费控事前采购申请', '费控事前采购', '费控', '费控事前采购流程', '费控事前流程', '发票查验及上传报销', '发票查验及上传报销', '上传报销', '发票查验'],
            administrativeList: ['1', '行政管理制度与流程', '行政管理制度流程', '行政管理制度', '行政管理', '行政', '行政管理流程', '学校相关资质使用申请流程', '学校相关资质使用申请', '学校相关资', '会议及配套周边的预订', '会议配套', '周边的预订', '教室的预订流程', '预订流程', '预订', '教室预订', '合同审批', '合同施印及存档', '存档', '合同施印', '合同', '印章审批流程', '印章流程', '审批流程', '印章'],
            appendixList: ['1', '附录','发票查验及上传报销','发票查验','上传报销', '邮件书写规范及收件人检索操作示例', '邮件', '邮件规范', '邮件书写规范', '书写规范', '书写', '收件人检索操作流程', '收件人', '员工优惠报名的适用范围', '员工优惠', '员工优惠报名的标准如下', '优惠报名', '员工优惠报名注意事项', '员工优惠 OA 申请流程及填写规范', '伯乐奖执行办法', '伯乐奖', '合同附加条款', '合同条款'],
            issue: ['1','常见问题','问题','题','问'],
            scene: ['1','常见场景','场景','景','场'],
            DataList: [{
                name: "劳动合同变更类型",
                title: "LabourParticulars",
                page: "89"
                }, {
                    name: "劳动合同变更流程",
                    title: "LabourParticulars",
                    page: "99"
                }, {
                    name: "三方协议签订流程",
                    title: "LabourParticulars",
                    page: "79"
                }, {
                    name: "坐班指纹打卡",
                    title: "ManpowerParticulars"
                }, {
                    name: "教师上课一卡通打卡",
                    title: "ManpowerParticulars1"
                }, {
                    name: "加班管理",
                    title: "ManpowerParticulars2"
                }, {
                    name: "带薪年假",
                    title: "ManpowerParticulars3",
                    page: "1"
                }, {
                    name: "法定节假日带薪休假期",
                    title: "ManpowerParticulars3",
                    page: "0"
                }, {
                    name: "病假",
                    title: "ManpowerParticulars3",
                    page: "2"
                }, {
                    name: "婚假",
                    title: "ManpowerParticulars3",
                    page: "3"
                }, {
                    name: "丧假",
                    title: "ManpowerParticulars3",
                    page: "4"
                }, {
                    name: "产假",
                    title: "ManpowerParticulars4"
                }, {
                    name: "事假",
                    title: "ManpowerParticulars3",
                    page: "6"
                }, {
                    name: "假勤申请及考勤确认",
                    title: "ManpowerParticulars3",
                    page: "7"
                }, {
                    name: "发薪时间",
                    title: "WelfareRemuneration1",
                    page: "11"
                }, {
                    name: "计薪周期",
                    title: "WelfareRemuneration1",
                    page: "11"
                }, {
                    name: "薪酬提示",
                    title: "WelfareRemuneration1",
                    page: "11"
                }, {
                    name: "绩效提示",
                    title: "WelfareRemuneration1",
                    page: "11"
                }, {
                    name: "课酬提示",
                    title: "WelfareRemuneration1",
                    page: "12"
                }, {
                    name: "个人所得税提示",
                    title: "WelfareRemuneration1",
                    page: "12"
                }, {
                    name: "EHR系统查询流程",
                    title: "WelfareRemuneration1",
                    page: "1"
                }, {
                    name: "云办公APP查询流程",
                    title: "WelfareRemuneration1",
                    page: "2"
                }, {
                    name: "法定福利",
                    title: "WelfareRemuneration1",
                    page: "91"
                }, {
                    name: "节日福利",
                    title: "WelfareRemuneration1",
                    page: "92"
                }, {
                    name: "生日/结婚/生育福利",
                    title: "WelfareRemuneration1",
                    page: "93"
                }, {
                    name: "员工年度体检",
                    title: "WelfareRemuneration1",
                    page: "94"
                }, {
                    name: "员工旅游",
                    title: "WelfareRemuneration1",
                    page: "94"
                }, {
                    name: "员工报班优惠",
                    title: "WelfareRemuneration1",
                    page: "96"
                }, {
                    name: "员工推荐奖励",
                    title: "WelfareRemuneration1",
                    page: "96"
                }, {
                    name: "抚恤",
                    title: "WelfareRemuneration1",
                    page: "96"
                }, {
                    name: "企业文化微信号",
                    title: "WelfareRemuneration1",
                    page: "99"
                }, {
                    name: "实习证明或在职证明",
                    title: "ApplyData1",
                    page: '1'
                }, {
                    name: "收入证明",
                    title: "ApplyData1",
                    page: '2'
                }, {
                    name: "人力资源印章",
                    title: "ApplyData1",
                    page: '3'
                }, {
                    name: "劳动合同原件及复印件",
                    title: "ApplyData1",
                    page: '4'
                }, {
                    name: "公司发票信息",
                    title: "Finance1"
                }, {
                    name: "事前费用申请操作流程",
                    title: "Finance2"
                }, {
                    name: "借款操作流程",
                    title: "Finance3"
                }, {
                    name: "事后费用报销操作流程",
                    title: "Finance4"
                }, {
                    name: "OA采购申请流程",
                    title: "AssetFlow1"
                }, {
                    name: "费控事前采购申请流程",
                    title: "AssetFlow3"
                }, {
                    name: "发票查验及上传报销",
                    title: "AssetFlow4"
                }, {
                    name: "学校相关资质使用申请流程",
                    title: "Administrative1"
                }, {
                    name: "会议及配套周边的预订",
                    title: "Administrative2"
                }, {
                    name: "教室的预订流程",
                    title: "Administrative3"
                }, {
                    name: "会议配套周边预订流程",
                    title: "Administrative4"
                }, {
                    name: "合同审批",
                    title: "Administrative5"
                }, {
                    name: "合同施印及存档",
                    title: "Administrative6"
                }, {
                    name: "印章审批流程",
                    title: "Administrative7"
                }, {
                    name: "邮件书写规范",
                    title: "Appendix1",
                    page: '12'
                }, {
                    name: "收件人检索操作流程",
                    title: "Appendix2"
                }, {
                    name: "员工优惠报名的适用范围",
                    title: "Appendix1",
                    page: '13'
                }, {
                    name: "员工优惠报名的标准如下",
                    title: "Appendix3"
                }, {
                    name: "员工优惠报名注意事项",
                    title: "Appendix1",
                    page: '14'
                }, {
                    name: "员工优惠 OA 申请流程及填写规范",
                    title: "Appendix4"
                }, {
                    name: "“伯乐奖”推荐细则",
                    title: "Appendix5"
                }, {
                    name: "“伯乐奖”推荐流程",
                    title: "Appendix1",
                    page: '15'
                }, {
                    name: "“伯乐奖”领取流程",
                    title: "Appendix1",
                    page: '16'
                }, {
                    name: "合同附加条款",
                    title: "Appendix1",
                    page: '17'
                },  {
                    name: "发票查验及上传报销",
                    title: "Scene",
                    page: '17'
                }, {
                    name: "差旅费用标准管理规定",
                    title: "Appendix6",
                    page: '17'
                }],
            dataInput: false,
            pageArray: [],
            set: true
        };
    },
    methods: {
        addFn() {
            var page = this.$route.params.code
            if (page == 111) {
                this.$router.push({
                    name: 'FinanceHome'
                })
            } else if (page == 222) {
                this.$router.push({
                    name: 'AssetFlow'
                })
            } else if (page == 333) {
                this.$router.push({
                    name: 'Issue'
                })
            } else if (page == 444) {
                this.$router.push({
                    name: "Labour"
                })
            } else if (page == 555) {
                this.$router.push({
                    name: "Manpower"
                })
            } else if (page == 666) {
                this.$router.push({
                    name: "WelfareRemuneration"
                })
            } else if (page == 777) {
                this.$router.push({
                    name: "ApplyData"
                })
            } else if (page == 888) {
                this.$router.push({
                    name: "HumanDirectory"
                })
            } else if (page == 999) {
                this.$router.push({
                    name: "AssetFlow1",
                    params: {
                        code: "11"
                    }
                })
            } else if (page == 1000) {
                this.$router.push({
                    name: "AssetFlow2"
                })
            } else if (page == 1001) {
                this.$router.push({
                    name: "AssetFlow3"
                })
            } else if (page == 1002) {
                this.$router.push({
                    name: "AssetFlow4"
                })
            } else if (page == 1003) {
                this.$router.push({
                    name: "Administrative"
                })
            } else if (page == 1004) {
                this.$router.push({
                    name: "Administrative1"
                })
            } else if (page == 1005) {
                this.$router.push({
                    name: "Administrative2"
                })
            } else if (page == 1111) {
                this.$router.push({
                    name: "Administrative3",
                    params:{code:"13"}
                })
            } else if (page == 1112) {
                this.$router.push({
                    name: "Administrative4"
                })
            } else if (page == 1113) {
                this.$router.push({
                    name: "Administrative5"
                })
            } else if (page == 1114) {
                this.$router.push({
                    name: "Administrative6"
                })
            } else if (page == 1115) {
                this.$router.push({
                    name: "Administrative7"
                })
            } else if (page == 1116) {
                this.$router.push({
                    name: "Appendix"
                })
            } else if (page == 1) {
                this.$router.push({
                    name: 'Appendix1',
                    params: {
                        code: "12"
                    }
                })
            } else if (page == 2) {
                this.$router.push({
                    name: 'Appendix2'
                })
            } else if (page == 3) {
                this.$router.push({
                    name: 'Appendix'
                })
            } else if (page == 4) {
                this.$router.push({
                    name: 'Appendix3'
                })
            } else if (page == 5) {
                this.$router.push({
                    name: 'Appendix4'
                })
            } else if (page == 6) {
                this.$router.push({
                    name: 'Appendix5'
                })
            } else if (page == '0000') {
                this.$router.push({
                    name: 'Scene'
                })
            } else if(page == '123321'){
                this.$router.push({
                    name: 'FinanceHome'
                })
            } else if(page == '123123123'){
                this.$router.push({
                    name: 'FinanceHome'
                })
            } else if(page == '1231231234'){
                this.$router.push({
                    name: 'AssetHome'
                })
            } else if(page == '1231231235'){
                this.$router.push({
                    name: 'AdministrativeHome'
                })
            } else if(page == 'q'){
                this.$router.push({
                    name: 'AdministrativeHome'
                })
            } else if (page == 'c'){
                this.$router.push({
                    name: 'AssetHome'
                })
            } else if (page == 'a'){
                this.$router.push({
                    name: 'HumanDirectory'
                })
            } else if (page == 'y'){
                this.$router.push({
                    name: 'Administrative3',
                    params:{code:"99"}
                })
            } else if (page == 'l'){
                this.$router.push({
                    name: 'Administrative9'
                })
            }
        },
        fooInput() {
            var ago = this
            var newArr = []
            this.pageArray = []
            var index = 1
            var Array = []
            var ArrayIn = []
            var str = ''
            if (this.dataInput == true) {
                return
            }
            this.dataInput = false
            setTimeout(function () {
                if (ago.keyword.length == 1) {
                    for (var i = 0; i < ago.DataList.length; i++) {
                        for (var j = 0; j < ago.DataList[i].name.length; j++) {
                            if (ago.keyword == ago.DataList[i].name[j]) {
                                newArr.push(ago.DataList[i].name)
                            }
                        }
                    }
                } else if (ago.keyword.length == 2) {
                    for (var i = 0; i < ago.DataList.length; i++) {
                        for (var j = 0; j < ago.DataList[i].name.length; j++) {
                            if (ago.DataList[i].name[j].length % 2 == 0 || index % 2 == 0) {
                                index++
                                ArrayIn = []
                                ArrayIn.push(ago.DataList[i].name[j])
                                Array.push(ArrayIn[0])
                                str = ''
                                for (var y = 0; y < Array.length; y++) {
                                    str += Array[y]
                                }
                                if (ago.keyword == str) {
                                    newArr.push(ago.DataList[i].name)
                                }
                            } else if (ago.DataList[i].name[j].length % 2 != 0) {
                                index++
                                Array = []
                                Array.push(ago.DataList[i].name[j])
                            }
                        }
                    }
                }
                var arr = newArr
                for (var i = 0; i < arr.length; i++) {
                    if (ago.pageArray.indexOf(arr[i]) == -1) {
                        ago.pageArray.push(arr[i]);
                    }
                }
                this.dataInput = true
            }, 1000);
        },
        addGetPage(item) {
            this.keyword = item
            var hais = this
            if(hais.set == false){
                return
            }
            hais.set = false
            setTimeout(function () {
                for (var i = 0; i < hais.DataList.length; i++) {
                    if (hais.DataList[i].name == item) {
                        hais.$router.push({name: hais.DataList[i].title,params:{code:hais.DataList[i].page}})
                    }
                }
                hais.pageArray = []
                hais.set = true
            },300)
        },
        pitchTitle(id) {
            if(id == 1){
                this.$router.push({name:"ManpowerParticulars",params:{code:"11"}})
            } else if(id == 3){
                this.$router.push({name:"ManpowerParticulars",params:{code:"11"}})
            } else if(id == 2){
                this.$router.push({name:"ManpowerParticulars5"})
            } else if(id == 3){
                this.$router.push({name:"ManpowerParticulars",params:{code:"11"}})
            } else if(id == 4){
                this.$router.push({name:"WelfareRemuneration1",params:{code:"2"}})
            } else if(id == 5){
                this.$router.push({name:"ManpowerParticulars3",params:{code:"1"}})                   
            } else if(id == 6){
                this.$router.push({name:"WelfareRemuneration1",params:{code:"94"}})                   
            } else if(id == 7){
                this.$router.push({name:"WelfareRemuneration"})                   
            } else if(id == 8){
                this.$router.push({name:"Appendix4",params:{code:"96"}})                   
            }
        },
        inputHandle() {
            var key = this.keyword
            if (this.labourList.indexOf(key) > 0) { // 劳动用工
                this.$router.push({
                    name: "Labour"
                })
            } else if (this.systemList.indexOf(key) > 0) { // 工时制度
                this.$router.push({
                    name: "Manpower"
                })
            } else if (this.welfareList.indexOf(key) > 0) { // 福利薪酬
                this.$router.push({
                    name: "WelfareRemuneration"
                })
            } else if (this.datumList.indexOf(key) > 0) { // 资料申请
                this.$router.push({
                    name: "ApplyData"
                })
            } else if (this.financeList.indexOf(key) > 0) { // 财务管理制度与流程
                this.$router.push({
                    name: "Finance"
                })
            } else if (this.assetList.indexOf(key) > 0) { // 资产管理制度于流程
                this.$router.push({
                    name: "Finance"
                })
            } else if (this.administrativeList.indexOf(key) > 0) { // 行政管理制度与流程
                this.$router.push({
                    name: "Finance"
                })
            } else if (this.appendixList.indexOf(key) > 0) { // 附录
                this.$router.push({
                    name: "Appendix"
                })
            } else if (this.issue.indexOf(key) > 0) { // 附录
                this.$router.push({
                    name: "Issue"
                })
            } else if (this.scene.indexOf(key) > 0) { // 附录
                this.$router.push({
                    name: "Scene"
                })
            } else {
                this.NoContent = true;
                this.hotSearchHide = false;
            }

        },
    },
    mounted() {}
};
</script>

<style scoped>
.searchBox {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
}

.nav {
    width: 100%;
    height: 9.7rem;
    text-align: center;
    line-height: 9.7rem;
    background: url(http://file.xdf.cn/uploads/191023/1369_20191023173037.png);
    background-size: 100%;
    color: #ffffff;
    font-size: 16px;
    position: relative;
}

.revocation {
    width: 12px;
    position: absolute;
    top: 15px;
    left: 14px;
}

.Input {
    width: 100%;
    height: 43px;
    margin-top: -38px;
    position: relative;
}

.Input img,
.Input input,
.Input h5 {
    position: absolute;
}

.Input img {
    width: 25px;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 12.5%;
    z-index: 999;
}

.Input input {
    width: 70%;
    height: 100%;
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 20px;
    border: none;
    font-size: 16px;
    padding-left: 10%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    outline: none;
}

.Input h5 {
    width: 82px;
    height: 100%;
    background: #ffaf2e;
    border-radius: 20px;
    right: 9%;
    text-align: center;
    line-height: 43px;
    font-size: 18px;
    color: #fff;
    font-weight: 500;
}

input::-webkit-input-placeholder {
    color: #bdbdbd;
}

input:-moz-placeholder {
    color: #bdbdbd;
}

input::-moz-placeholder {
    color: #bdbdbd;
}

input:-ms-input-placeholder {
    color: #bdbdbd;
}

.hotTitle {
    margin: 32px 0;
    text-align: center;
    color: #565656;
    font-size: 18px;
}

.hotSearch {
    width: 90%;
    margin: 0 auto;
}

.hotSearch p {
    width: 21%;
    height: 38px;
    line-height: 38px;
    text-align: center;
    margin-right: 5%;
    background: rgba(255, 255, 255, 1);
    -webkit-box-shadow: 0px 3px 12px 0px rgba(185, 185, 185, 0.5);
    box-shadow: 0px 3px 12px 0px rgba(185, 185, 185, 0.5);
    border-radius: 5px;
    float: left;
    margin-bottom: 12px;
    font-size: 14px;
    color: #11c7a5;
}

.hotSearch p:nth-child(4),
.hotSearch p:nth-child(8) {
    margin-right: 0%;
}

.NoContentClass {
    width: 200px;
    display: block;
    margin: 100px auto;
}

.addPage {
    width: 80%;
    margin: 10px auto;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0px 3px 12px 0px rgba(135, 135, 136, 0.5);
}

.addPage p {
    height: 35px;
    padding-left: 35px;
    line-height: 30px;
    font-size: 15px;
    border-bottom: 1px solid rgba(36, 17, 82, 0.5)
}

.addPage p:last-child {
    border-bottom: none
}
</style>



// WEBPACK FOOTER //
// src/components/searchPage/search.vue